<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Ajustes de existencias</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Productos</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Existencia</a>
        </li>
        <li class="breadcrumb-item active">Ajustes de existencia</li>
      </ol>
    </div>
    <div class="card" v-if="mevengo === true">
      <div class="card-header">
        <div class="form-group">
          <div class="row">
             <div class="col-md-3">
              <div class="form-group">
                <label><strong>Producto</strong> </label>
                <p v-text="stock.product.name"/>
              </div>
            </div>
           <div class="col-md-3">
              <div class="form-group">
                <label><strong>Código del producto</strong> </label>
                <p v-text="stock.code"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Sucursal del producto</strong> </label>
                <p v-text="stock.place.name"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Medida del producto</strong> </label>
                <p v-text="stock.measure.equal"/>
              </div>
            </div>

          </div>
          <div class="row">
             <div class="col-md-3">
              <div class="form-group">
                <label><strong>Existencia actual</strong> </label>
                <p v-text="stock.stock"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Precio de compra actual</strong> </label>
                <p v-text="stock.purchase_price"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Precio de venta actual</strong> </label>
                <p v-text="stock.sales_price"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="stock.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Existencia previa</th>
              <th>Existencia nueva</th>
              <th>Descripción</th>
              <th>Responsable</th>
              <th>Fecha de actualización de existencia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stocks in stocksArray" :key="stocks.id">
              <td v-text="stocks.previous_stock"></td>
              <td v-text="stocks.stock_adjustment"></td>
              <td v-text="stocks.description"></td>
              <td v-text="stocks.name"></td>
              <td v-text="stocks.created_at"></td>

            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
            <div class="card-body">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search, checkboxmanual)" v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
      </div>
    </div>
    <div v-else class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

</template>


<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
import ladda from "ladda";
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    'masked-input': MaskedInput,
  },
  data () {
    return {
      mevengo: false,
      checkboxmanual: false,
      arrayPlaces: [],
      arrayMeasure: [],
      arrayProduct: [],
      tituloModalActivar: '',
      critery: 'code',
      code: '',
      location: '',
      idmeasure: 0,
      idplace: 0,
      idproduct: 0,
      purchase_price: '',
      total_cost: 0.0,
      sales_price: '',
      special_price: '',
      stocksArray: [],
      id: 0,
      idproduct: 0,
      tipoAccion: 0,
      titleModal: '',
      equal: '',
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      errorPrices:'',
      offset: 3,
      search: '',
      stock: {

      },
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      }),
    }
  },
  validations: {

  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber : function(){
        if(!this.pagination.to){
            return [];
        }
        var from = this.pagination.current_page - this.offset;
        if(from < 1){
            from = 1;
        }
        var to = from + (this.offset * 2);
        if(to >= this.pagination.last_page)
        {
            to = this.pagination.last_page;
        }
        var pagesArray = [];
        while(from <= to){
            pagesArray.push(from);
            from++;
        }
        return pagesArray;
    },
  },
  mounted () {
    this.getStock(this.$route.query.item);
    this.fetchData(1, this.$route.query.item, this.search, this.checkboxmanual);
  },
  methods: {
    changePage (page, search, checkboxmanual) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, me.product.id, search, checkboxmanual)
    },
    async fetchData (page, id, search, checkboxmanual) {
      let me = this
      const response = await axios.get(
        `/api/admin/stock/adjustment?page=${page}&id=${id}&search=${search}&checkboxmanual=${checkboxmanual}`
      )
      .then(function (response) {
        var respuesta = response.data
        me.stocksArray = respuesta.stocks.data
        me.pagination = respuesta.pagination

      })
      .catch(function (error) {
        console.log(error)
      })
    },
    getStock (id) {
      let me = this
      axios.get(`/api/admin/stock/getById?id=${id}`)
        .then(function (response) {
          me.stock = response.data.stock[0]
          me.mevengo = true;
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    openModal(accion, data = []) {
      let me = this;
      switch (accion) {
        case "update": {
          me.$refs.existencia_modal.open();
          this.titleModal = "Actualizar Existencia";
          this.code = data["code"],
          this.total_cost = data["total_cost"];
          this.purchase_price = this.formatQuetzales(data['purchase_price'])
          this.sales_price = this.formatQuetzales(data['sales_price'])
          this.special_price = this.formatQuetzales(data['special_price'])
          this.stock = data["stock"],
          this.location = data["location"],
          this.idmeasure = data["idmeasure"],
          this.idplace = data["idplace"],
          this.idproduct = data["idproduct"],
          this.id = data["id"];
          this.tipoAccion = 2;
          break;
        }
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea desactivar la existencia?'
          this.id = data['id']
          this.tipoAccion = 3
          break
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea activar la existencia?'
          this.id = data['id']
          this.tipoAccion = 4
          break
        }
        case 'code':
        {
          me.code = ''
          var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          var charactersLength = characters.length;
          for ( var i = 0; i < 10; i++ ) {
              me.code += characters.charAt(Math.floor(Math.random() * charactersLength));
          }
          break;
        }
      }
    },
    closeModal() {
      this.$v.$reset();
      this.id=0;
      this.$refs.existencia_modal.close();
      this.stock = 0.0;
      this.location = '';
      this.idmeasure = 0;
      this.idplace = 0;
      this.idproduct = 0;
      this.id = 0;
      this.titleModal = "";
      this.sales_price='';
      this.special_price='';
      this.purchase_price='';
      this.tituloModalActivar = '';
      this.$refs.activar_modal.close();
      this.errorPrices = '';
      this.fetchData(this.pagination.current_page, this.product.id, this.search, this.checkboxmanual);
    },

    validarTecla: function(e) {
      if (e.keyCode === 13) {

      } else if (e.keyCode === 50) {
        console.log('@ was pressed');
      }
    },
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
.imgRedondo {
  width: 150px !important;
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/products/Stocks.vue